export const bankData = [
  { code: "003", nameEn: "STANDARD CHARTERED BANK (HONG KONG) LIMITED", nameZh: "渣打銀行(香港)有限公司" },
  { code: "004", nameEn: "THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED", nameZh: "香港上海匯豐銀行有限公司" },
  { code: "005", nameEn: "CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK", nameZh: "-" },
  { code: "006", nameEn: "CITIBANK, N.A.", nameZh: "花旗銀行" },
  { code: "007", nameEn: "JPMORGAN CHASE BANK, N.A.", nameZh: "-" },
  { code: "009", nameEn: "CHINA CONSTRUCTION BANK (ASIA) CORPORATION LIMITED", nameZh: "中國建設銀行(亞洲)股份有限公司" },
  { code: "012", nameEn: "BANK OF CHINA (HONG KONG) LIMITED", nameZh: "中國銀行(香港)有限公司" },
  { code: "015", nameEn: "THE BANK OF EAST ASIA, LIMITED", nameZh: "東亞銀行有限公司" },
  { code: "016", nameEn: "DBS BANK (HONG KONG) LIMITED", nameZh: "星展銀行(香港)有限公司" },
  { code: "018", nameEn: "CHINA CITIC BANK INTERNATIONAL LIMITED", nameZh: "中信銀行(國際)有限公司" },
  { code: "020", nameEn: "CMB WING LUNG BANK LIMITED", nameZh: "招商永隆銀行有限公司" },
  { code: "022", nameEn: "OVERSEA-CHINESE BANKING CORPORATION LTD.", nameZh: "-" },
  { code: "024", nameEn: "HANG SENG BANK LTD.", nameZh: "恒生銀行有限公司" },
  { code: "025", nameEn: "SHANGHAI COMMERCIAL BANK LTD.", nameZh: "上海商業銀行有限公司" },
  { code: "027", nameEn: "BANK OF COMMUNICATIONS CO., LTD", nameZh: "交通銀行股份有限公司" },
  { code: "028", nameEn: "PUBLIC BANK (HONG KONG) LIMITED", nameZh: "大眾銀行(香港)有限公司" },
  { code: "035", nameEn: "OCBC BANK (HONG KONG) LIMITED", nameZh: "華僑銀行(香港)有限公司" },
  { code: "038", nameEn: "TAI YAU BANK LTD", nameZh: "大有銀行有限公司" },
  { code: "039", nameEn: "CHIYU BANKING CORPORATION LTD.", nameZh: "集友銀行有限公司" },
  { code: "040", nameEn: "DAH SING BANK, LTD.", nameZh: "大新銀行有限公司" },
  { code: "041", nameEn: "CHONG HING BANK LIMITED", nameZh: "創興銀行有限公司" },
  { code: "043", nameEn: "NANYANG COMMERCIAL BANK, LTD.", nameZh: "南洋商業銀行有限公司" },
  { code: "045", nameEn: "UCO BANK", nameZh: "-" },
  { code: "046", nameEn: "KEB HANA BANK", nameZh: "-" },
  { code: "047", nameEn: "MUFG BANK, LTD.", nameZh: "-" },
  { code: "049", nameEn: "BANGKOK BANK PUBLIC COMPANY LIMITED", nameZh: "-" },
  { code: "050", nameEn: "INDIAN OVERSEAS BANK", nameZh: "-" },
  { code: "054", nameEn: "DEUTSCHE BANK AG", nameZh: "-" },
  { code: "055", nameEn: "BANK OF AMERICA, NATIONAL ASSOCIATION", nameZh: "-" },
  { code: "056", nameEn: "BNP PARIBAS", nameZh: "-" },
  { code: "058", nameEn: "BANK OF INDIA", nameZh: "-" },
  { code: "060", nameEn: "NATIONAL BANK OF PAKISTAN", nameZh: "-" },
  { code: "061", nameEn: "TAI SANG BANK LIMITED", nameZh: "大生銀行有限公司" },
  { code: "063", nameEn: "MALAYAN BANKING BERHAD (MAYBANK)", nameZh: "馬來亞銀行" },
  { code: "065", nameEn: "SUMITOMO MITSUI BANKING CORPORATION", nameZh: "-" },
  { code: "066", nameEn: "PT. BANK NEGARA INDONESIA (PERSERO) TBK.", nameZh: "-" },
  { code: "067", nameEn: "BDO UNIBANK, INC.", nameZh: "金融銀行有限公司" },
  { code: "071", nameEn: "UNITED OVERSEAS BANK LTD.", nameZh: "大華銀行有限公司" },
  { code: "072", nameEn: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA (ASIA) LIMITED", nameZh: "中國工商銀行(亞洲)有限公司" },
  { code: "074", nameEn: "BARCLAYS BANK PLC.", nameZh: "-" },
  { code: "076", nameEn: "THE BANK OF NOVA SCOTIA", nameZh: "-" },
  { code: "080", nameEn: "ROYAL BANK OF CANADA", nameZh: "加拿大皇家銀行" },
  { code: "081", nameEn: "SOCIETE GENERALE", nameZh: "法國興業銀行" },
  { code: "082", nameEn: "STATE BANK OF INDIA", nameZh: "-" },
  { code: "085", nameEn: "THE TORONTO-DOMINION BANK", nameZh: "多倫多道明銀行" },
  { code: "086", nameEn: "BANK OF MONTREAL", nameZh: "-" },
  { code: "092", nameEn: "CANADIAN IMPERIAL BANK OF COMMERCE", nameZh: "加拿大帝國商業銀行" },
  { code: "103", nameEn: "UBS AG, HONG KONG", nameZh: "-" },
  { code: "106", nameEn: "HSBC BANK USA, NATIONAL ASSOCIATION", nameZh: "美國滙豐銀行" },
  { code: "109", nameEn: "MIZUHO BANK, LTD.", nameZh: "-" },
  { code: "113", nameEn: "DZ BANK AG DEUTSCHE ZENTRAL-GENOSSENSCHAFTSBANK", nameZh: "-" },
  { code: "118", nameEn: "WOORI BANK", nameZh: "友利銀行" },
  { code: "119", nameEn: "PHILIPPINE NATIONAL BANK", nameZh: "-" },
  { code: "128", nameEn: "FUBON BANK (HONG KONG) LIMITED", nameZh: "富邦銀行(香港)有限公司" },
  { code: "138", nameEn: "MITSUBISHI UFJ TRUST AND BANKING CORPORATION", nameZh: "-" },
  { code: "139", nameEn: "THE BANK OF NEW YORK MELLON", nameZh: "-" },
  { code: "145", nameEn: "ING BANK N.V.", nameZh: "-" },
  { code: "147", nameEn: "BANCO BILBAO VIZCAYA ARGENTARIA, S.A.", nameZh: "-" },
  { code: "150", nameEn: "NATIONAL AUSTRALIA BANK LIMITED", nameZh: "澳大利亞國民銀行" },
  { code: "152", nameEn: "AUSTRALIA AND NEW ZEALAND BANKING GROUP LTD.", nameZh: "澳新銀行集團有限公司" },
  { code: "153", nameEn: "COMMONWEALTH BANK OF AUSTRALIA", nameZh: "澳洲聯邦銀行" },
  { code: "161", nameEn: "INTESA SANPAOLO S.P.A.", nameZh: "意大利聯合聖保羅銀行股份有限公司" },
  { code: "164", nameEn: "UNICREDIT BANK AG", nameZh: "裕信(德國)銀行股份有限公司" },
  { code: "170", nameEn: "THE CHIBA BANK LTD", nameZh: "-" },
  { code: "178", nameEn: "KBC BANK N.V.", nameZh: "比利時聯合銀行" },
  { code: "180", nameEn: "WELLS FARGO BANK, N.A.", nameZh: "-" },
  { code: "183", nameEn: "COÖPERATIEVE RABOBANK U.A.", nameZh: "-" },
  { code: "185", nameEn: "DBS BANK LTD, HONG KONG BRANCH", nameZh: "-" },
  { code: "186", nameEn: "THE SHIZUOKA BANK LTD.", nameZh: "靜岡銀行" },
  { code: "198", nameEn: "HUA NAN COMMERCIAL BANK LTD.", nameZh: "華南商業銀行股份有限公司" },
  { code: "199", nameEn: "THE SHIGA BANK, LTD.", nameZh: "-" },
  { code: "201", nameEn: "BANK OF TAIWAN", nameZh: "臺灣銀行股份有限公司" },
  { code: "202", nameEn: "THE CHUGOKU BANK LIMITED", nameZh: "-" },
  { code: "203", nameEn: "FIRST COMMERCIAL BANK", nameZh: "第一商業銀行股份有限公司" },
  { code: "206", nameEn: "CHANG HWA COMMERCIAL BANK LTD.", nameZh: "彰化商業銀行股份有限公司" },
  { code: "210", nameEn: "NATIXIS", nameZh: "-" },
  { code: "214", nameEn: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED", nameZh: "中國工商銀行股份有限公司" },
  { code: "220", nameEn: "STATE STREET BANK AND TRUST COMPANY", nameZh: "-" },
  { code: "221", nameEn: "CHINA CONSTRUCTION BANK CORPORATION", nameZh: "中國建設銀行股份有限公司" },
  { code: "222", nameEn: "AGRICULTURAL BANK OF CHINA LIMITED", nameZh: "中國農業銀行股份有限公司" },
  { code: "227", nameEn: "ERSTE GROUP BANK AG", nameZh: "-" },
  { code: "229", nameEn: "CTBC BANK CO., LTD.", nameZh: "中國信託商業銀行股份有限公司" },
  { code: "230", nameEn: "TAIWAN BUSINESS BANK, LTD.", nameZh: "臺灣中小企業銀行股份有限公司" },
  { code: "236", nameEn: "CATHAY UNITED BANK COMPANY, LIMITED", nameZh: "國泰世華商業銀行股份有限公司" },
  { code: "237", nameEn: "EFG BANK AG", nameZh: "瑞士盈豐銀行股份有限公司" },
  { code: "238", nameEn: "CHINA MERCHANTS BANK CO., LTD.", nameZh: "招商銀行股份有限公司" },
  { code: "239", nameEn: "TAIPEI FUBON COMMERCIAL BANK CO., LTD.", nameZh: "台北富邦商業銀行股份有限公司" },
  { code: "241", nameEn: "BANK SINOPAC", nameZh: "永豐商業銀行股份有限公司" },
  { code: "242", nameEn: "MEGA INTERNATIONAL COMMERCIAL BANK CO., LTD.", nameZh: "兆豐國際商業銀行股份有限公司" },
  { code: "243", nameEn: "E.SUN COMMERCIAL BANK, LTD.", nameZh: "玉山商業銀行股份有限公司" },
  { code: "245", nameEn: "TAISHIN INTERNATIONAL BANK CO., LTD.", nameZh: "台新國際商業銀行股份有限公司" },
  { code: "248", nameEn: "HONG LEONG BANK BERHAD", nameZh: "豐隆銀行有限公司" },
  { code: "249", nameEn: "STANDARD CHARTERED BANK HONG KONG BRANCH", nameZh: "渣打銀行" },
  { code: "250", nameEn: "CITIBANK (HONG KONG) LIMITED", nameZh: "花旗銀行(香港)有限公司" },
  { code: "251", nameEn: "ICICI BANK LIMITED", nameZh: "-" },
  { code: "254", nameEn: "MELLI BANK PLC", nameZh: "-" },
  { code: "258", nameEn: "EAST WEST BANK", nameZh: "華美銀行" },
  { code: "260", nameEn: "FAR EASTERN INTERNATIONAL BANK", nameZh: "遠東國際商業銀行股份有限公司" },
  { code: "263", nameEn: "CATHAY BANK", nameZh: "國泰銀行" },
  { code: "264", nameEn: "LAND BANK OF TAIWAN CO., LTD.", nameZh: "臺灣土地銀行股份有限公司" },
  { code: "265", nameEn: "TAIWAN COOPERATIVE BANK, LTD.", nameZh: "合作金庫商業銀行股份有限公司" },
  { code: "267", nameEn: "BANCO SANTANDER S.A.", nameZh: "西班牙桑坦德銀行有限公司" },
  { code: "269", nameEn: "THE SHANGHAI COMMERCIAL & SAVINGS BANK LTD.", nameZh: "上海商業儲蓄銀行股份有限公司" },
  { code: "271", nameEn: "INDUSTRIAL BANK OF KOREA", nameZh: "-" },
  { code: "272", nameEn: "BANK OF SINGAPORE LIMITED", nameZh: "新加坡銀行有限公司" },
  { code: "273", nameEn: "SHINHAN BANK", nameZh: "-" },
  { code: "274", nameEn: "O-BANK CO., LTD", nameZh: "王道商業銀行股份有限公司" },
  { code: "276", nameEn: "CHINA DEVELOPMENT BANK", nameZh: "國家開發銀行" },
  { code: "277", nameEn: "FIRST ABU DHABI BANK PJSC", nameZh: "-" },
  { code: "278", nameEn: "BANK J. SAFRA SARASIN LTD.", nameZh: "-" },
  { code: "308", nameEn: "HDFC BANK LIMITED", nameZh: "-" },
  { code: "309", nameEn: "UNION BANCAIRE PRIVEE, UBP SA", nameZh: "-" },
  { code: "316", nameEn: "SKANDINAVISKA ENSKILDA BANKEN AB", nameZh: "-" },
  { code: "320", nameEn: "BANK JULIUS BAER & CO. LTD.", nameZh: "-" },
  { code: "324", nameEn: "CREDIT INDUSTRIEL ET COMMERCIAL", nameZh: "法國工商銀行" },
  { code: "337", nameEn: "TAIWAN SHIN KONG COMMERCIAL BANK CO., LTD.", nameZh: "臺灣新光商業銀行股份有限公司" },
  { code: "338", nameEn: "BANK OF CHINA LIMITED, HONG KONG BRANCH", nameZh: "中國銀行股份有限公司" },
  { code: "339", nameEn: "CA INDOSUEZ (SWITZERLAND) SA", nameZh: "-" },
  { code: "342", nameEn: "LGT BANK AG", nameZh: "LGT皇家銀行(香港)" },
  { code: "345", nameEn: "SHANGHAI PUDONG DEVELOPMENT BANK CO., LTD.", nameZh: "上海浦東發展銀行股份有限公司" },
  { code: "353", nameEn: "CHINA MINSHENG BANKING CORP., LTD.", nameZh: "中國民生銀行股份有限公司" },
  { code: "359", nameEn: "CHINA GUANGFA BANK CO., LTD.", nameZh: "廣發銀行股份有限公司" },
  { code: "361", nameEn: "CHINA BOHAI BANK CO., LTD.", nameZh: "渤海銀行股份有限公司" },
  { code: "364", nameEn: "BANQUE PICTET & CIE SA", nameZh: "-" },
  { code: "365", nameEn: "BANK OF DONGGUAN CO., LTD", nameZh: "東莞銀行股份有限公司" },
  { code: "368", nameEn: "CHINA EVERBRIGHT BANK CO., LTD.", nameZh: "中國光大銀行股份有限公司" },
  { code: "371", nameEn: "SUMITOMO MITSUI TRUST BANK, LIMITED", nameZh: "-" },
  { code: "372", nameEn: "BANK OF SHANGHAI (HONG KONG) LIMITED", nameZh: "上海銀行(香港)有限公司" },
  { code: "374", nameEn: "CIMB BANK BERHAD", nameZh: "-" },
  { code: "376", nameEn: "NONGHYUP BANK", nameZh: "-" },
  { code: "377", nameEn: "INDUSTRIAL BANK CO., LTD", nameZh: "興業銀行股份有限公司" },
  { code: "378", nameEn: "YUANTA COMMERCIAL BANK CO., LTD.", nameZh: "元大商業銀行股份有限公司" },
  { code: "379", nameEn: "MASHREQ BANK - PUBLIC SHAREHOLDING COMPANY", nameZh: "-" },
  { code: "381", nameEn: "KOOKMIN BANK", nameZh: "-" },
  { code: "382", nameEn: "BANK OF COMMUNICATIONS (HONG KONG) LIMITED", nameZh: "交通銀行(香港)有限公司" },
  { code: "383", nameEn: "CHINA ZHESHANG BANK CO., LTD.", nameZh: "浙商銀行股份有限公司" },
  { code: "384", nameEn: "MORGAN STANLEY BANK ASIA LIMITED", nameZh: "摩根士丹利銀行亞洲有限公司" },
  { code: "385", nameEn: "PING AN BANK CO., LTD.", nameZh: "平安銀行股份有限公司" },
  { code: "386", nameEn: "HUA XIA BANK CO., LIMITED", nameZh: "華夏銀行股份有限公司" },
  { code: "387", nameEn: "ZA BANK LIMITED", nameZh: "眾安銀行有限公司" },
  { code: "388", nameEn: "LIVI BANK LIMITED", nameZh: "理慧銀行有限公司" },
  { code: "389", nameEn: "MOX BANK LIMITED", nameZh: "-" },
  { code: "390", nameEn: "WELAB BANK LIMITED", nameZh: "匯立銀行有限公司" },
  { code: "391", nameEn: "FUSION BANK LIMITED", nameZh: "富融銀行有限公司" },
  { code: "392", nameEn: "PAO BANK LIMITED", nameZh: "-" },
  { code: "393", nameEn: "ANT BANK (HONG KONG) LIMITED", nameZh: "螞蟻銀行(香港)有限公司" },
  { code: "394", nameEn: "QATAR NATIONAL BANK (Q.P.S.C.)", nameZh: "卡塔爾國家銀行" },
  { code: "395", nameEn: "AIRSTAR BANK LIMITED", nameZh: "天星銀行有限公司" },
  { code: "396", nameEn: "THE KOREA DEVELOPMENT BANK", nameZh: "-" },
  { code: "397", nameEn: "CHINA CITIC BANK CORPORATION LIMITED", nameZh: "中信銀行股份有限公司" },
  { code: "802", nameEn: "HONG KONG SECURITIES CLEARING COMPANY LIMITED", nameZh: "-" },
  { code: "868", nameEn: "CONTINUOUS LINKED SETTLEMENT BANK INTERNATIONAL", nameZh: "-" }
]